/**
 * Регистрирует diagonal-hatching паттерн (косая штриховка //) в инстансе карты MapBox
 * под именем `dots-pattern-{suffix}`. Использует canvas → data URL → loadImage,
 * что гарантированно работает в MapBox GL JS 2.x.
 *
 * @param {object} map          Инстанс mapboxgl.Map
 * @param {string} suffix       Суффикс имени (например 'green', 'red', 'speed')
 * @param {string} color        CSS-цвет линий штриховки
 * @param {object} [opts]
 * @param {number} [opts.size=8]       Размер тайла — задаёт расстояние между линиями
 * @param {number} [opts.lineWidth=1]  Толщина линии
 */
export const registerDotsPattern = (map, suffix, color, opts) => {
    const id = `dots-pattern-${suffix}`;
    if (map.hasImage(id)) {
        return;
    }
    const { size = 8, lineWidth = 1 } = opts || {};
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, size, size);
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.lineCap = 'square';
    ctx.globalAlpha = 0.7;
    // Косая штриховка // под 45°
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(size, size);
    ctx.moveTo(-size / 2, size / 2);
    ctx.lineTo(size / 2, -size / 2);
    ctx.moveTo(size / 2, size + size / 2);
    ctx.lineTo(size + size / 2, size / 2);
    ctx.stroke();
    const dataUrl = canvas.toDataURL('image/png');
    map.loadImage(dataUrl, (err, image) => {
        if (err) {
            console.error(`[hatch] loadImage error for ${id}:`, err);
            return;
        }
        if (!map.hasImage(id)) {
            map.addImage(id, image, { sdf: false, pixelRatio: 2 });
        }
    });
};
